<template>
  <div class="menu">
    <ul class="menu1">
      <li v-for="(items, key) in navList"
          :key="key"
          v-if="getToken"
          :class="{ active: active_idx == key }"
          @click="activeFun(key)">
        <i :class="items.icon"></i>
        <p>{{ items.text }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import Cookies from 'vue-cookie'

export default {
  name: "comMenu",
  data() {
    return {
      active_idx: 0,
      navList: [
        { text: "样式", icon: 'iconfont icon-yangshi'},
        { text: "模板", icon: 'iconfont icon-moban'},
        { text: "文章", icon: 'iconfont icon-wenzhang'}
      ]
    };
  },
  methods: {
    activeFun(idx) {
      this.active_idx = idx;
      this.$emit("msg-menu", idx);
    }
  },
  computed: {
    getToken () {
      return Cookies.get('token')
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/icon-font/iconfont.css';

.menu {
  min-width: 85px;
  width: 110px;
  color: #535353;
  background-color: #ffffff;
  border-right: 1px solid #ebebeb;
  padding-top: 20px;
  position: fixed;
  left: 0;
  top: 60px;
  bottom: 0;
  box-sizing: border-box;
  z-index: 1000;

  li {
    cursor: pointer;
    width: 100%;
    padding: 10px 0;
    p {
      font-size: 14px;
      text-align: center;
      line-height: 30px;
    }
    i {
      margin: auto;
      text-align: center;
      font-size: 28px;
    }

    &:hover {
      color: $color;
      .icon0 {
        @extend .icon0_;
      }
      .icon1 {
        @extend .icon1_;
      }
      .icon2 {
        @extend .icon2_;
      }
    }
  }

  .active {
    color: $color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-menu.vue